import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DashboardPreviewCard = ({ dashboard }) => {
  const navigate = useNavigate();

  const handleTryDemo = () => {
    navigate(dashboard?.path);
  };

  return (
    <div className="bg-white border-2 border-green-100 rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 group">
      {/* Thumbnail Section */}
      <div className="relative aspect-video bg-gradient-to-br from-green-50 to-emerald-50">
        <img
          src={dashboard?.thumbnail}
          alt={dashboard?.alt || `${dashboard?.name} dashboard preview showing key features and interface`}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-green-900/70 via-green-900/30 to-transparent" />
        <div className="absolute bottom-3 left-3 right-3">
          <div className="bg-green-900/80 backdrop-blur-sm px-3 py-2 rounded-lg border border-amber-400/30">
            <p className="text-white text-xs font-medium">{dashboard?.name}</p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="p-5">
        {/* Header */}
        <div className="flex items-start gap-3 mb-3">
          <div className="bg-gradient-to-br from-green-100 to-emerald-100 text-green-700 p-2 rounded-lg">
            <Icon name={dashboard?.icon} size={20} />
          </div>
          <div className="flex-1">
            <h3 className="font-heading text-lg font-bold text-gray-900 mb-1">
              {dashboard?.name}
            </h3>
            <p className="text-xs text-gray-600">
              {dashboard?.description}
            </p>
          </div>
        </div>

        {/* Features List */}
        <div className="mb-4">
          <h4 className="caption text-xs font-semibold text-green-700 mb-2 uppercase tracking-wide">
            Key Features
          </h4>
          <ul className="space-y-2">
            {dashboard?.features?.slice(0, 3)?.map((feature, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-600">
                <Icon name="CheckCircle" size={16} className="text-green-600 mt-0.5 flex-shrink-0" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          {dashboard?.features?.length > 3 && (
            <p className="text-xs text-green-700 mt-2 font-medium">
              +{dashboard?.features?.length - 3} more features
            </p>
          )}
        </div>

        {/* Tags */}
        <div className="flex flex-wrap gap-2 mb-4">
          <span className="px-2 py-1 bg-amber-100 text-amber-800 text-xs rounded-md capitalize font-medium">
            {dashboard?.role}
          </span>
          <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-md capitalize font-medium">
            {dashboard?.function}
          </span>
        </div>

        {/* Actions */}
        <div className="flex gap-2">
          <Button
            fullWidth
            variant="default"
            iconName="MousePointer"
            onClick={handleTryDemo}
          >
            Try Demo
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DashboardPreviewCard;